import { Annotation } from '@rossum/api-client/annotations';
import { useGetComments } from '../../core';
import { CommentsDrawer } from './CommentsDrawer';

type CommentsDrawerContainerProps = {
  annotation: Annotation;
  onClose: () => void;
};

export const CommentsDrawerContainer = ({
  annotation,
  onClose,
}: CommentsDrawerContainerProps) => {
  const { data: comments, isFetching } = useGetComments({
    annotation: annotation.id,
  });

  return (
    <CommentsDrawer
      open
      annotation={annotation}
      comments={comments}
      isLoading={isFetching}
      onClose={onClose}
    />
  );
};
